import request from '@/utils/request'

const base = '/db/reverse-apply-info';

// 出库申请信息添加
export function pagedQuery(data) {
    return request({
        url: base + '/paged-query',
        method: 'post',
        data
    })
}

// 红冲关联工单物料查询
export function relatedOrderNoDetail(data) {
    return request({
        url: base + '/related-order-no-detail',
        method: 'post',
        data
    })
}

// 红冲申请提交
export function apply(data) {
    return request({
        url: base + '/apply',
        method: 'post',
        data
    })
}

// 红冲审批
export function audit(data) {
    return request({
        url: base + '/audit',
        method: 'post',
        data
    })
}

// 红冲详情
export function detail(data) {
    return request({
        url: base + '/' + data,
        method: 'get'
    })
}

// 一键导出
export function reportExport(data){
    return request({
        url:base +'/report-export',
        method:'post',
        data
    })
}